module.exports = __webpack_public_path__ + "static/media/WATER_LOW_BR.d8740a08.mp4";